import React from 'react';
import { ServicesSection, WhyChooseUs } from '../components/Sections';
import FooterSection from '../components/Footer';

const AboutPage = ({ isDark }) => (
  <>
    <section className={`relative py-32 transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a]' : 'bg-gray-900'}`}>
      <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]' : 'bg-gradient-to-b from-gray-800 to-gray-900'}`}></div>
      <div className="relative z-10 container-custom text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">About <span className="text-[#c9a962]">Us</span></h1>
        <p className="text-xl text-gray-400">Your trusted partner for premium car rentals in Udaipur</p>
      </div>
    </section>
    <section className={`py-20 transition-colors duration-300 ${isDark ? 'bg-[#0d0d0d]' : 'bg-gray-100'}`}>
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className={`text-4xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-900'}`}>Welcome to <span className="text-[#c9a962]">Brothers Car Rental</span></h2>
            <p className={`mb-6 leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>We are Udaipur's premier self-drive car rental company, dedicated to providing luxury vehicles for unforgettable experiences. With over 5 years of experience in the industry, we understand what our customers need for the perfect journey.</p>
            <p className={`mb-8 leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Our fleet includes the finest luxury cars from top manufacturers like BMW, Mercedes-Benz, Audi, Toyota, and more. Whether you need a car for a business trip, family vacation, wedding, or special occasion, we have the perfect vehicle for you.</p>
            <div className="grid grid-cols-2 gap-6">
              <div className={`p-6 rounded-xl ${isDark ? 'bg-[#1a1a1a]' : 'bg-white shadow-lg'}`}>
                <h3 className="text-3xl font-bold text-[#c9a962] mb-2">10+</h3>
                <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Premium Cars</p>
              </div>
              <div className={`p-6 rounded-xl ${isDark ? 'bg-[#1a1a1a]' : 'bg-white shadow-lg'}`}>
                <h3 className="text-3xl font-bold text-[#c9a962] mb-2">500+</h3>
                <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Happy Customers</p>
              </div>
              <div className={`p-6 rounded-xl ${isDark ? 'bg-[#1a1a1a]' : 'bg-white shadow-lg'}`}>
                <h3 className="text-3xl font-bold text-[#c9a962] mb-2">5+</h3>
                <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Years Experience</p>
              </div>
              <div className={`p-6 rounded-xl ${isDark ? 'bg-[#1a1a1a]' : 'bg-white shadow-lg'}`}>
                <h3 className="text-3xl font-bold text-[#c9a962] mb-2">24/7</h3>
                <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Support Available</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800" alt="About Us" className="w-full rounded-xl border-2 border-[#c9a962]/30" />
          </div>
        </div>
      </div>
    </section>
    <ServicesSection isDark={isDark} />
    <WhyChooseUs isDark={isDark} />
    <FooterSection isDark={isDark} />
  </>
);

export default AboutPage;
